export default __webpack_public_path__ + "static/devops-i-vantaggi-nello-sviluppo-717b58e64d41abae1935421339a19bd4.jpg";